import { useState, useMemo, FC } from 'react';
import { AdAccountContext } from './AdAccountContext';
import { useGetAllAdAccounts } from '../hooks/useGetAllAdAccounts';
import { useFacebookLoginContext } from './FacebookLoginContext';

export const AdAccountContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { loginCode } = useFacebookLoginContext();
  const { data: allAdAccountIds = [], isLoading } = useGetAllAdAccounts(loginCode);

  const [adAccountIds, setAdAccountIds] = useState<Set<string>>(new Set([]));

  const unselectedAdAccountIds = useMemo(
    () => allAdAccountIds.filter((adAccount) => !adAccountIds.has(adAccount)),
    [adAccountIds, allAdAccountIds],
  );

  const clearAllAdAccounts = () => setAdAccountIds(new Set([]));
  const selectAllAdAccounts = () => setAdAccountIds(new Set(allAdAccountIds));
  const addAdAccounts = (adAccountId: string) =>
    setAdAccountIds((prev) => new Set([...prev, adAccountId]));
  const removeAdAccounts = (adAccountId: string) =>
    setAdAccountIds((prev) => new Set([...prev].filter((accountId) => accountId !== adAccountId)));

  const contextValue = {
    adAccountIds: [...adAccountIds],
    unselectedAdAccountIds,
    allAdAccountIds,
    clearAllAdAccounts,
    selectAllAdAccounts,
    addAdAccounts,
    removeAdAccounts,
    setAdAccountIds,
    isLoading,
  };

  return <AdAccountContext.Provider value={contextValue}>{children}</AdAccountContext.Provider>;
};
